import React, { useState } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { UnmountClosed } from 'react-collapse';

import { ICONS } from 'Components/utils/icon/icons';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';

import { Icon } from 'Components/frameworks/icon/Icon';

export const AccordionItem = ({
  bottomLeft,
  bottomRight,
  children,
  component,
  dataTestId,
  iconName,
  isFirstItem,
  isLastItem,
  isNull,
  isOpenedByDefault,
  topLeft,
  topRight,
  trackingData,
}) => {
  const [isOpened, setIsOpened] = useState(isOpenedByDefault);
  const { trackClickEvent } = useTrackEvent();

  if (component) {
    return <div className="mt-30">{component}</div>;
  }

  return (
    !isNull && (
      <React.Fragment>
        <div
          className={classnames('mb-15 flex gap-20', {
            'border-t-1 border-dashed pt-10': !isFirstItem && !isLastItem,
            'mt-30 border-t-5 pt-10': !isFirstItem && isLastItem,
          })}
        >
          {iconName && <Icon className="text-sienna" name={iconName} width="1.875rem" />}
          <div className="grid w-full grid-cols-2">
            <div className="grid">
              <p className="text-14">{topLeft}</p>
              {bottomLeft && <p className="text-14 font-bold">{bottomLeft}</p>}
            </div>
            <div className="grid max-h-40 justify-end">
              <p className="text-end text-14">{topRight}</p>
              {bottomRight && (
                <p className="text-end text-14 font-bold text-orange">{bottomRight}</p>
              )}
            </div>
          </div>
        </div>
        {children && (
          <div className="flex w-full justify-end">
            <button
              data-testid={dataTestId}
              type="button"
              onClick={() => {
                if (trackingData && !isOpened) {
                  trackClickEvent(trackingData.event, trackingData.payload);
                }
                setIsOpened(!isOpened);
              }}
            >
              <Icon name={ICONS.ARROW_TOP} rotation={isOpened ? 0 : 180} />
            </button>
          </div>
        )}
        <UnmountClosed isOpened={isOpened}>{children}</UnmountClosed>
      </React.Fragment>
    )
  );
};
